export const LINK_THEME = {
    primary: 'primary',
    secondary: 'secondary',
    button: 'button',
    inline: 'inline',
} as const
